


















import { Component, Vue } from 'vue-property-decorator';
	import {
		Instance
	} from '@/classes/TayehApi';
import UploadImage from '@/components/UploadImage.vue'
import { Prop } from 'vue-property-decorator';

	@Component({
		components: {
			UploadImage
		}
	})
	export default class ShopInventoryBrandCreateForm extends Vue {
		@Prop() private readonly instanceId: number;
		name: string = null;
		translated_name: string = null;
		logo_id: string = null;

		async create() {
			try {
				let res = await Instance.createBrand(this.instanceId, {name: this.name, translated_name: this.translated_name, logo_id: this.logo_id});
				if (res.data.err) {
					this.$message({
						showClose: true,
						message: res.data.err,
						type: 'error',
						duration: 5000
					});
				} else {
					this.$message({
						showClose: true,
						message: 'برند با موفقیت ایجاد شد.',
						type: 'success',
						duration: 5000
					});
				}
			} catch {
				this.$message({
					showClose: true,
					message: 'لطفا دوباره تلاش کنید.',
					type: 'error',
					duration: 10000
				});
			} finally {
				this.$emit('created')
			}
		}
	}
